import { render, staticRenderFns } from "./SimpleSelectCheckbox.vue?vue&type=template&id=2f8270be&scoped=true&"
import script from "./SimpleSelectCheckbox.vue?vue&type=script&lang=js&"
export * from "./SimpleSelectCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSelectCheckbox.vue?vue&type=style&index=0&id=2f8270be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8270be",
  null
  
)

export default component.exports